import React from "react";
import Logo from "../../Assets/Images/PrinceLogo.svg";
import BackgroundVideo from "../../Assets/Images/teaser.mp4";
import "../../Assets/Css/ComingSoon.css";

const ComingSoon = () => {
  return (
    <div className="coming-soon-container">
      {/* Header Section */}
      <div className="header-soon">
        <div className="logo-container-soon">
          <img src={Logo} alt="Company Logo" className="logo-soon" />
        </div>
      </div>

      {/* Video Section */}
      <div className="video-section">
        {/* Background Video */}
        <video className="background-video" autoPlay loop muted playsInline>
          <source src={BackgroundVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Overlay Layer */}
        <div className="overlay">
          <h1 className="coming-soon-text">Coming Soon</h1>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
